import router from './router'
import store from './store'
import i18n from '@/locales'

const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  let key = to.meta.title
  const title = i18n.t(`nav.${key}`)
  if (key && title) {
    document.title = title
  } else {
    document.title = i18n.t('nav.app')
  }
  const hasToken = store.getters.hasToken
  console.log('router before:', hasToken, store.getters.token, to, from)
  if (hasToken) {
    if (to.path === '/login') {
      console.log('to home:')
      next({ name: 'home' })
    } else {
      console.log('not to home:')
      next()
      // const hasRoles = store.getters.roles && store.getters.roles.length > 0
      // if (hasRoles) {

      //   console.log('has role next:')
      //   next()
      // } else {
      //   console.log('no roels:')
      //   try {
      //     console.log('getuser:')
      //     const { roles } = await store.dispatch('user/getInfo')
      //     const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
      //     next({ ...to, replace: true })
      //   } catch (err) {
      //     console.log('chatch:')
      //     await store.dispatch('logout')
      //     next({ path: '/login' })
      //   }
      // }
    }
  } else {
    console.log('has not token:', hasToken, whiteList.indexOf(to.path))
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next({ path: '/login' })
    }
  }
})